import React from "react";
import {TextField } from './TextField'

export class EmailField extends TextField {
    getFieldType(): string {
        return "email";
    }

    getErrorText(): string {
        let error = super.getErrorText();
        if (error) {
            return error;
        }

        if (this.hasValue()) {
            if (!/^([\w-+]+(?:\.[\w-+]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,13}(?:\.[a-z]{2})?)$/i.test(this.getValue())) {
                return "Email Address format is incorrect";
            }
        }

        return null;
    }
}